import { Navigate, Route, Routes, useMatch, useNavigate, useParams } from 'react-router-dom';
import { ArrowBack, AssignmentLate } from '@mui/icons-material';
import { useCallback, useEffect, useState } from 'react';
import Sidenav from '../../components/Sidebar/Sidenav';
import NavItem from '../../components/Sidebar/NavItem';
import { useMarketContext } from '../../contexts/MarketContext';
import useMarkets from '../../hooks/data/useMarkets';
import { useFetch } from '../../hooks';
import BasicData from './pages/BasicInfo';
import MarketPages from './pages/types';

const MarketRouter = (): JSX.Element => {
  const { pathnameBase } = useMatch({ path: '/markets/:id/*' })!;
  return (
    <Routes>
      <Route path="/" element={<Navigate to={`${pathnameBase}/basic-info`} replace />} />
      <Route path="/basic-info" element={<BasicData />} />
    </Routes>
  );
};

export const Market = (): JSX.Element => {
  const { id } = useParams<{ id: string }>();
  const { handleUnselectMarket, setLoading, setMarket } = useMarketContext();
  const match = useMatch({ path: '/markets/:id/*' });
  const [activePage, setPage] = useState<MarketPages>();
  const repository = useMarkets();
  const { data, loading, refetch } = useFetch((selectedId?: string) => repository.fetch((selectedId ?? id)!), {
    ignoreFirstCall: true,
  });
  const history = useNavigate();

  useEffect(() => {
    if (id !== 'new') {
      refetch(id);
    }
  }, [id, refetch]);

  useEffect(() => setLoading(loading), [loading, setLoading]);

  useEffect(() => {
    setMarket(data ?? null);
  }, [data, setMarket]);

  useEffect(() => {
    if (match) {
      const { pathnameBase, pathname: _path } = match;

      const initialRoute = _path.replace(pathnameBase, '').replace('/', '');

      setPage(initialRoute as MarketPages);
    }
  }, [match]);

  const handlePageChange = useCallback(
    (page: MarketPages) => {
      history(page);
    },
    [history]
  );

  return (
    <>
      <Sidenav>
        <>
          <NavItem title="voltar" icon={<ArrowBack />} onClick={() => handleUnselectMarket()} />
          <NavItem
            title="dados básicos"
            icon={<AssignmentLate />}
            onClick={() => handlePageChange(MarketPages.BasicInfo)}
          />
        </>
      </Sidenav>
      <MarketRouter />
    </>
  );
};

export default Market;
